import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import CreatePortal from "@/components/CreatePortal/CreatePortal.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import {
  normalize_organization_profile,
} from "@/utils/organization_profile";
import {
  get_branding_style,
  homeFilterMethods,
  html_to_plain_text,
} from "./home_filter_helper";

export default {
  components: {
    HomeNavBar,
    CreatePortal,
    StickyNav,
    InactivityModal,
  },
  data: () => ({
    token_exists: false,
    user_details: {},
    active_profile: null,
    saved_branding: null,
    recent_activities: [],
    company: {} // ✅ must be object, not array
  }),
  computed: {
    branding_style() {
      return get_branding_style(this.saved_branding);
    },
    organization() {
      return normalize_organization_profile(
        this.company || {},
        this.user_details,
        this.saved_branding
      );
    },
    company_description() {
      return html_to_plain_text(this.company?.description);
    },
    profile_completion() {
      const checks = [
        this.organization.company_name,
        this.organization.type_of_organization,
        this.organization.logo,
        this.organization.description,
        this.organization.location,
        this.organization.email || this.organization.tell_number,
      ];

      const completed = checks.filter(Boolean).length;
      return Math.round((completed / checks.length) * 100);
    },
    setup_items() {
      const org = this.organization || {};

      return [
        { label: "Organisation name", done: !!org.company_name },
        { label: "Organisation type", done: !!org.type_of_organization },
        { label: "Logo", done: !!org.logo },
        { label: "Description", done: !!org.description },
        { label: "Location", done: !!org.location },
        { label: "Contact details", done: !!(org.email || org.tell_number) },
      ];
    },
  },
  mounted() {
    this.token_exists = !!get_token();

    this.user_details = get_user_details() || {};

    this.saved_branding = this.get_saved_branding();
    this.apply_branding_to_platform(this.saved_branding);

    // ✅ wait until user_details is ready
    this.$nextTick(() => {
      this.fetch_company_profile();
    });

    window.addEventListener(
      "organization-branding-updated",
      this.handle_organization_branding_updated
    );
  },
  beforeUnmount() {
    window.removeEventListener("organization-branding-updated", this.handle_organization_branding_updated);
  },
  methods: {
    ...homeFilterMethods,
  },
};
